/**
 * Ежедневные задания: GET /quests/daily, claim (§22.3).
 */

import { apiFetch } from "./client.js";

export type DailyQuestView = {
  readonly slot: number;
  readonly questId: string;
  readonly box: string;
  readonly progress: number;
  readonly target: number;
  readonly rewardCrystals: number;
  readonly rewardXp: number;
  readonly claimed: boolean;
  readonly claimable: boolean;
};

export type DailyQuestsView = {
  readonly ecoDay: string;
  readonly ecoDayEndsAt: string;
  readonly quests: readonly DailyQuestView[];
};

export async function fetchDailyQuests(
  token: string,
  signal?: AbortSignal,
): Promise<DailyQuestsView> {
  return apiFetch<DailyQuestsView>("/quests/daily", {
    token,
    ...(signal ? { signal } : {}),
  });
}

export async function claimDailyQuest(
  slot: number,
  token: string,
  idempotencyKey: string,
): Promise<DailyQuestsView & { wallet: { hive: number; debt: number } }> {
  return apiFetch<DailyQuestsView & { wallet: { hive: number; debt: number } }>(
    `/quests/daily/${slot}/claim`,
    {
      method: "POST",
      token,
      headers: { "Idempotency-Key": idempotencyKey },
    },
  );
}
